import { ArrowClockwise, List } from '@phosphor-icons/react';
import { Button } from '@/components/ui/Button';
import { ThemeToggle } from '@/components/ui/ThemeToggle';
import { useReleases } from '@/hooks/useReleases';

export function TopBar({ onOpenSidebar }: { onOpenSidebar: () => void }) {
  const { isFetching, refetch } = useReleases();

  return (
    <header className="sticky top-0 z-[var(--z-sticky)] border-b border-line surface-header backdrop-blur-md">
      <div className="flex items-center gap-3 px-4 md:px-7 h-16">
        <button
          type="button"
          onClick={onOpenSidebar}
          aria-label="Open navigation"
          className="lg:hidden grid place-items-center w-9 h-9 rounded-md border border-line-2 text-muted hover:text-ink hover:border-brand transition-colors"
        >
          <List size={18} weight="bold" />
        </button>

        <ThemeToggle className="ml-auto shrink-0" />

        <Button
          variant="solid"
          size="sm"
          className="shrink-0"
          onClick={() => refetch()}
          disabled={isFetching}
        >
          <ArrowClockwise
            size={14}
            weight="bold"
            aria-hidden
            className={isFetching ? 'animate-spin' : ''}
          />
          Refresh
        </Button>
      </div>
    </header>
  );
}
